import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { CommonDateRange, Heading } from 'components';
import { ownVehicleProfitableList } from '_services/reportService/reportService';
import StorageService from 'utils/StorageServices';
import Loading from 'pages/Loading';
import { FiRefreshCcw } from 'react-icons/fi';
import { BsDownload } from 'react-icons/bs';

const OwnVehicleReport = () => {
  const [ownVehicleData, setOwnVehicleData] = useState([]);
  const [loading, setLoading] = useState(false);

  const currentDate = new Date();
  const firstDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1);
  const lastDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);

  const [selectedRange, setSelectedRange] = useState({
    startDate: moment().startOf('month'),
    endDate: moment().endOf('month'),
  });

  const [filter, setFilter] = useState({
    limit: 100,
    offset: 1,
  });

  useEffect(() => {
    getProfitLossReportList();
  }, [filter]);

  const getProfitLossReportList = async () => {
    setLoading(true)
    const payload = {
      ...filter,
      company_id: StorageService.getCompanyId(),
      start_date: moment(selectedRange.startDate).format('YYYY-MM-DD'),
      end_date: moment(selectedRange.endDate).format('YYYY-MM-DD'),
    };

    try {
      const res = await ownVehicleProfitableList(payload);
      if (res?.responseCode === 200) {
        setOwnVehicleData(res?.data);
        setLoading(false)
      } else {
        setLoading(false)
        console.error('Error fetching data');
      }
    } catch (error) {
      setLoading(false)
      console.error(error);
    }
  };

  const handleApply = (newRange) => {
    setSelectedRange(newRange);
    setFilter((s) => ({
      ...s,
      offset: 1,
    }));
  };

  const resetFunction = () => {
    const newStartDate = moment().startOf('month');
    const newEndDate = moment().endOf('month');

    setSelectedRange({
      startDate: newStartDate,
      endDate: newEndDate,
    });
    // const newStartDate = moment(firstDay).subtract(31, 'days');
    // const newEndDate = moment(lastDay);

    // setSelectedRange({
    //   startDate: newStartDate,
    //   endDate: newEndDate,
    // });

    setFilter((s) => ({
      ...s,
      offset: 1,
    }));
  };

  return (
    <>
      <div className='__znDe_mainBx'>
        <div>
          <div className='panel-heading'>
            <h2><span>Own Vehicle Profit</span></h2>

            <div className='panel-ctrls report-control'>
              <div>
                <CommonDateRange
                  key={`${selectedRange.startDate}-${selectedRange.endDate}`}
                  initialStartDate={selectedRange.startDate}
                  initialEndDate={selectedRange.endDate}
                  onApply={handleApply}
                />
              </div>

              <button className='__bxs_srBtn'>
                <BsDownload />
              </button>

              <button className='__bxs_srBtn' onClick={(e) => resetFunction(e)}>
                <FiRefreshCcw />
              </button>
            </div>

          </div>
        </div>

        <div className="_mrktLoad_mainBx __main_p_n_l">


          {loading ? <div style={{ position: 'relative', width: '100%',display:'flex', justifyContent:'center', alignItems:'center' }}> <Loading /> </div> :
            <div className="_pNl_listBx">
              <div className="_pNl_list_otrBx">
                {/* <h4>Own Vehicle P&L Report</h4>
                <p>{`From ${moment(selectedRange.startDate).format('DD MMM YYYY')} - ${moment(selectedRange.endDate).format('DD MMM YYYY')}`}</p> */}


                <div className='clear-both text-center p-10'>
                  <div class="__hrlMx_head" >
                    {/* <p>{profitLossData?.company?.company ? profitLossData?.company?.company : '-'}</p> */}
                    <p>Hexaware</p>
                    <h4>Own Vehicle P&L Report</h4>
                    <h5>From <span> {moment(selectedRange.startDate).format("DD-MMM-YYYY")}</span> To <span> {moment(selectedRange.endDate).format("DD-MMM-YYYY")}</span> </h5>
                  </div>
                </div>

                {/* Data rendering for ownVehicleData */}
                <div className='_pNl_list_inrBx'>
                  <div className='__pNlFlx' >
                    <span>Own/ Leased Vehicle Trips</span> <span>{ownVehicleData?.total_trips}</span>
                  </div>

                  <div className='__pNlFlx'>
                    <span>Revenue</span> <span>₹ {ownVehicleData?.total_party_freight}</span>
                  </div>

                  <div className='__pNlFlx'>
                    <span>Trip Charges</span> <span>₹ {ownVehicleData?.total_truck_freight}</span>
                  </div>

                  <div className='__pNlFlx'>
                    <span>Claims</span> <span>₹ {ownVehicleData?.claims}</span>
                  </div>

                  <div className='__pNlFlx'>
                    <span>Other Charges</span> <span>₹ {ownVehicleData?.other_charges}</span>
                  </div>

                  <div className='__pNlFlx __plTotalBl' >
                    <span>Trip Profit</span> <span>₹ {ownVehicleData?.total_profit_loss}</span>
                  </div>

                  <div className='__pNlFlx'>
                    <span>Servicing</span> <span>₹ {ownVehicleData?.servicing}</span>
                  </div>

                  <div className='__pNlFlx'>
                    <span>Documents</span> <span>₹ {ownVehicleData?.documents}</span>
                  </div>

                  <div className='__pNlFlx'>
                    <span>Salary</span> <span>₹ {ownVehicleData?.salary}</span>
                  </div>

                  <div className='__pNlFlx'>
                    <span>Fastag (Not Associated)</span> <span>₹ {ownVehicleData?.fastag}</span>
                  </div>

                  <div className='__pNlFlx __plTotalYl' >
                    <span>Profit from Own/ Leased (A)</span> <span>₹ {ownVehicleData?.profit_A}</span>
                  </div>

                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </>
  );
};

export default OwnVehicleReport;
